import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { validateField } from '../../../../../utilities/validation/formValidation';
import { validateOtpAsync, checkInvoicePermissionAsync } from '../../PersonalAreaInvoicesAsyncThunk';
import messageIcon from './images/message-icon.svg';
import microphoneIcon from './images/microphone-icon.svg';

const OtpVerifyCodePage = (props) => {
    const [formData, setFormData] = useState({
        code: { value: '', error: '', validationRules: { required: true, requiredMessage: 'נא הזן קוד אימות', regexName: 'numbersRegex', regexMessage: 'קוד אימות לא תקין' } },
    });

    useEffect(() => {
        
    }, []);

    return (
        <div className='otp-verify-code-page'>
            <form noValidate id='form-verify-code' onSubmit={(e) => e.preventDefault()}>
                
                <div className='otp-verify-code'>

                    <div className={props.phoneNumber ? 'phone-icon' : 'envelope-icon'}></div>

                    <div className='title-wrapper'> לצפייה בחשבונית </div>
                    <div className='text-wrapper'>
                        {
                            props.phoneNumber ?
                                <>שלחנו לך קוד חד פעמי ל-<span>{props.phoneNumber}</span></>
                                :
                                <>שלחנו לך קוד חד פעמי למייל <span>{props.email}</span></>
                        }
                    </div>

                    <div className='input-wrapper'>
                        <div className='input-title'> מה הקוד שהתקבל? </div>
                        <div className='input-field'>
                            <TextInput
                                placeholder={'קוד אימות'}
                                autoComplete='one-time-code'
                                name='form-verify-code'
                                value={formData.code.value}
                                type='text'
                                maxLength={'6'}
                                error={formData.code.error}
                                onChange={(e) => handleOnChange('code', e.target.value)}
                            />                        
                        </div>
                    </div>

                    <div className='resend-buttons'>
                        <div className='resend-link' onClick={() => resendCodeClick()} style={{backgroundImage:messageIcon.bg()}}> הקוד לא הגיע, שלחו לי שוב </div>
                        {
                            props.phoneNumber &&
                            <>
                                <div className='link-seperator'></div>
                                <div className='call-me-link' onClick={() => callMeClick()} style={{backgroundImage:microphoneIcon.bg()}}> שלחו לי את הקוד בהודעה קולית </div>                            
                            </>
                        }
                    </div>

                    <div className='button-wrapper'>
                        <BtnSubmit
                            type='submit'
                            text={'נמשיך לחשבונית'}
                            className='otp-verify-code-button'
                            onclick={verifyCodeButtonClick}
                        />                    
                    </div>

                </div>

            </form>
        </div>
    );


    function handleOnChange(fieldName, value) {
        let data = formData;
        const error = validateField(data[fieldName].validationRules, value);
        data[fieldName].error = error;
        data[fieldName].value = value;
        setFormData({ ...data });
    }


    function resendCodeClick() {
        props.checkInvoicePermissionAsync();
    }


    function callMeClick() {
        props.checkInvoicePermissionAsync({ sendTextAsVoice: true });
    }
    

    async function verifyCodeButtonClick() {
        let data = formData;
        if (data['code'].error) { return; }

        const result = await props.validateOtpAsync({ otpCode: data['code'].value });
        const isSuccess = result.payload;

        if (!isSuccess) {            
            data['code'].error = data['code'].validationRules.regexMessage;
            setFormData({ ...data });
        } 
    }

};

const mapStateToProps = (state) => {
    return {
        phoneNumber: state.personalAreaInvoicesPage.checkInvoicePermissionResult?.phoneNumber,
        email: state.personalAreaInvoicesPage.checkInvoicePermissionResult?.email
    };
};

const mapDispatchToProps = {
    validateOtpAsync,
    checkInvoicePermissionAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodePage);
